/* unplugin-vue-components disabled */import script from "./AdvertisingSpaceManagement.vue?vue&type=script&setup=true&name=ApplicationClassification&lang=js"
export * from "./AdvertisingSpaceManagement.vue?vue&type=script&setup=true&name=ApplicationClassification&lang=js"

import "./AdvertisingSpaceManagement.vue?vue&type=style&index=0&id=54e8559a&lang=scss&scoped=true"

import exportComponent from "E:\\new-admin\\3.0\\ruoyi-vue3-cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54e8559a"]])

export default __exports__